export default __webpack_public_path__ + "static/media/Cart.781f9a44.svg";